import api from "../../api";
import type {
  ContentCardData,
  ContentSectionConfig,
  HomeApiItem,
  TopicContentsPage,
} from "../../../@types/portalAluno";
import { PORTAL_TOPIC_PAGE_SIZE } from "../../../config/portalAluno/constants";
import { asText } from "../../../utils/portalAluno/coerce";
import { mapApiItemsToCards } from "../../../utils/portalAluno/mappers/contentCardMapper";

export const getContentTags = async (): Promise<string[]> => {
  const response = await api.get("mobile/t1/tags");

  const seenTags = new Set<string>();

  const items: unknown[] = Array.isArray(response.data) ? response.data : [];

  return items.reduce<string[]>((tags, item) => {
    const tag = asText(item);
    const key = tag?.toLowerCase();

    if (!tag || !key || seenTags.has(key)) return tags;

    seenTags.add(key);
    tags.push(tag);
    return tags;
  }, []);
};

export const getContentsByTag = async (
  section: ContentSectionConfig,
  tag: string,
  offset: number
): Promise<TopicContentsPage> => {
  const response = await api.get<HomeApiItem[]>(section.topicContentsPath, {
    params: { tag, offset, limite: PORTAL_TOPIC_PAGE_SIZE },
  });

  const cards: ContentCardData[] = mapApiItemsToCards(
    response.data,
    section.kind
  );

  return { cards, itemCount: cards.length };
};
